<script setup lang="ts">
import { ref } from "vue";
import { renderEmail } from "~/utilities/render-email";
import { images } from "~/utilities/images";

const navigation = ref([
  { to: "/bli-kund", text: "Bli kund" },
  { to: "/elavtal", text: "Elavtal" },
  { to: "/foretag-brf", text: "Företag/BRF  " },
  { to: "/salj-din-el", text: "Sälj din el" },
  { to: "/kundservice", text: "Kundservice" },
  { to: "/nyheter", text: " Nyheter" },
  { to: "/om-oss", text: "Om oss" },
]);

onMounted(() => {
  renderEmail()
});

</script>

<template>
  <div class="footer bg-dark-blue text-gray-light pt-30 pb-110">
    <div class="container mx-auto max-lg:max-w-lg">
      <div class="mb-70">
        <div class="flex justify-center">
          <router-link to="/" class="logo mb-20 block max-w-2/3">
            <svgo-logo width="100%" class="max-lg:mx-auto"/>
          </router-link>
        </div>

        <p class="text-center text-20 mb-40">
          Svensk Kärnkraft AB är ett privatägt elhandelsbolag med säte i Malmö.&nbsp;&nbsp;Org nr: 559215-6078
        </p>

        <div class="flex-col lg:flex lg:flex-row items-center justify-center flex-wrap">
          <div v-for="(nav, i) in navigation" :key="i" class="mx-20 mb-8">
            <nuxt-link
              class="text-20 font-semibold hover:text-cyan"
              :to="nav.to"
              :key="i"
            >
              {{ nav.text }}
            </nuxt-link>
          </div>
        </div>
      </div>
      <div class="content flex-col lg:flex lg:flex-row justify-center items-center gap-30">
        <div class="text-20 mb-40 ml-20 md:mb-0 lg:ml-0">
          <div class="leading-normal">
            <p><span class="font-semibold">Ring oss:</span> 010-1014020</p>
            <p>Måndag – Torsdag 09.00-17.00</p>
            <p>Fredag 09.00-16.00</p>
            <p>Dag före helgdag 09.00-12.00</p>
            <p><span class="font-semibold">Maila oss: </span><span class="protect"></span></p>
          </div>
        </div>
        <div class="flex justify-center items-center gap-30">
          <NuxtImg
            alt="Call"
            class="w-[12rem]"
            loading="lazy"
            :src="images.callFooter"
          />
        </div>
      </div>

      <div class="mt-50 flex items-center justify-center gap-80 flex-wrap">
        <div class="flex">
          <a href="https://www.facebook.com/KarnkraftSe" class="flex items-center mr-40" target="_blank">
            <div class="border-2 border-white rounded-xl w-25 h-25 flex items-center justify-center mr-10" style="width: 30px; height: 30px; border-radius: 10px"><svgo-facebook width="15"/></div>Facebook
          </a>
          <a href="https://x.com/KarnkraftSe" class="flex items-center" target="_blank">
            <div class="border-2 border-white rounded-xl w-25 h-25 flex items-center justify-center mr-10" style="width: 30px; height: 30px; border-radius: 10px"><svgo-x-icon width="20"/></div>X
          </a>
        </div>

        <div class="flex-col lg:flex lg:flex-row items-center justify-between flex-wrap gap-60">
          <nuxt-link to="/villkor" class="block mr-25">Användarvillkor</nuxt-link>
          <nuxt-link class="block mr-25" to="/integritetspolicy">Personuppgiftspolicy</nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
